const fonts = {};

fonts.gtAmerica =
  "'GT America', 'helvetica neue', helvetica, arial, sans-serif";
fonts.gtAmericaExpanded =
  "'GT America Expanded', 'helvetica neue', helvetica, arial, sans-serif";

export default fonts;
